import GameStepBase from '../game_step_base';
import {DEEP_LINK_MAP} from '../../../../components/external_links/handlers/external_links_base_handler_consts';
import FreePlayConfirmationGameStepDependenciesFactory from './free_play_confirmation_gamestep_dependencies_factory';

export default class FreePlayConfirmationGameStep extends GameStepBase {
    static CLASS = 'FreePlayConfirmationGameStep';

    init(params) {
        super.init(params);
        this.dependenciesFactory = params.dependenciesFactory || FreePlayConfirmationGameStepDependenciesFactory.create({
            serviceFactory: this.serviceFactory
        });
    }

    run(gameOptions) {
        if(!this.serviceFactory.oAuth2Service().isAuthorized()) {
            this.throwError('17', `${this.getClassName()} should be called only for authorized user`, {gameOptions});
        }

        if(gameOptions.freePlayData || gameOptions.skipFreePlay) {
            return Promise.resolve(gameOptions);
        }

        if(gameOptions.referrerId === DEEP_LINK_MAP.MY_ACCOUNT_DL_MY_CHALLENGES) {
            return Promise.resolve(gameOptions);
        }

        return this.serviceFactory.freePlayService().getFreePlaysForGameType(gameOptions.gameType)
            .then(vouchers => {
                if(!vouchers || vouchers.length === 0) {
                    return gameOptions;
                }

                return this.dependenciesFactory.showFreePlayConfirmationMessage(gameOptions.gameType)
                                        .then(() => {
                                            return Object.assign(gameOptions, {
                                                freePlayData: {
                                                    freePlayId: vouchers[0].ID * 1,
                                                    freePlayType: vouchers[0].FreePlayTypeId * 1
                                                }
                                            })
                                        })
                    .catch(() => {
                        return Promise.resolve(gameOptions);
                    });

            });


    }
}